var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2616_5688)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.102 24C12.5347 24.0005 11.982 23.8205 11.5237 23.4862C11.0654 23.1518 10.7254 22.6804 10.5527 22.14L8.74 16.444H7.62667C7.05916 16.4447 6.50616 16.2647 6.04772 15.9302C5.58928 15.5957 5.24918 15.124 5.07667 14.5833L4 11.2H8.03867L5.90867 8H26.0913L23.9613 11.2H28L26.9233 14.584C26.7507 15.1245 26.4106 15.5961 25.9521 15.9305C25.4937 16.2649 24.9408 16.4447 24.3733 16.444H23.26L21.4467 22.14C21.2741 22.6804 20.934 23.1519 20.4757 23.4863C20.0174 23.8207 19.4646 24.0006 18.8973 24H13.102ZM11.7333 14.8887C11.7333 15.748 12.3767 16.4447 13.1707 16.4447C13.964 16.4447 14.6073 15.748 14.6073 14.8887C14.6073 14.03 13.964 13.3333 13.1707 13.3333C12.3773 13.3333 11.7333 14.03 11.7333 14.8887ZM20.2667 14.8887C20.2667 15.748 19.6233 16.4447 18.8293 16.4447C18.036 16.4447 17.3927 15.748 17.3927 14.8887C17.3927 14.03 18.036 13.3333 18.8293 13.3333C19.6227 13.3333 20.2667 14.03 20.2667 14.8887Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2616_5688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(4 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCow);
export default __webpack_public_path__ + "static/media/COW.781c3a9485d8a0997664eb129454f794.svg";
export { ForwardRef as ReactComponent };